import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import { useNavigate } from 'react-router-dom';

export default function PrivacyPolicyPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-32 pb-24">
        <div className="container mx-auto px-6 max-w-4xl">
          <div className="flex items-center justify-between mb-6">
            <h1 className="text-4xl lg:text-5xl font-bold text-gray-900">
              Política de Privacidad
            </h1>
            <button
              onClick={() => navigate('/')}
              className="flex items-center gap-2 bg-emerald-600 text-white px-6 py-3 rounded-lg hover:bg-emerald-700 transition-colors font-medium whitespace-nowrap cursor-pointer"
            >
              <i className="ri-arrow-left-line"></i>
              Volver al inicio
            </button>
          </div>
          <p className="text-gray-600 mb-12">Última actualización: {new Date().toLocaleDateString('es-ES')}</p>

          <div className="prose prose-lg max-w-none space-y-8">
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Información General</h2>
              <p className="text-gray-700 leading-relaxed">
                PROTECPLUS INGENIERÍA, en cumplimiento del Reglamento (UE) 2016/679 del Parlamento Europeo y del Consejo, de 27 de abril de 2016, relativo a la protección de las personas físicas en lo que respecta al tratamiento de datos personales y a la libre circulación de estos datos (RGPD) y la Ley Orgánica 3/2018, de 5 de diciembre, de Protección de Datos Personales y garantía de los derechos digitales (LOPDGDD), informa a los usuarios de este sitio web sobre su política de protección de datos.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Responsable del Tratamiento</h2>
              <div className="bg-emerald-50 p-6 rounded-lg">
                <p className="text-gray-700"><strong>Identidad:</strong> PROTECPLUS INGENIERÍA</p>
                <p className="text-gray-700"><strong>Dirección:</strong> Avenida de Madrid, 86 Nave 3 - 28500 Arganda del Rey, Madrid</p>
                <p className="text-gray-700"><strong>Email:</strong> info@protecplus.es</p>
                <p className="text-gray-700"><strong>Teléfono:</strong> +34 900 123 456</p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Datos Recopilados</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Los datos personales que podemos recopilar incluyen:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>Datos de identificación: nombre, apellidos, DNI/NIF</li>
                <li>Datos de contacto: dirección postal, teléfono, email</li>
                <li>Datos profesionales: empresa, cargo, sector de actividad</li>
                <li>Datos de navegación: dirección IP, cookies, datos de conexión</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Finalidad del Tratamiento</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Los datos personales serán tratados para las siguientes finalidades:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>Gestión de consultas y solicitudes de información</li>
                <li>Prestación de servicios contratados</li>
                <li>Envío de comunicaciones comerciales (con consentimiento previo)</li>
                <li>Cumplimiento de obligaciones legales</li>
                <li>Mejora de nuestros servicios y experiencia de usuario</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Base Legal del Tratamiento</h2>
              <p className="text-gray-700 leading-relaxed">
                El tratamiento de sus datos se basa en: el consentimiento del interesado, la ejecución de un contrato, el cumplimiento de obligaciones legales y el interés legítimo del responsable.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Conservación de Datos</h2>
              <p className="text-gray-700 leading-relaxed">
                Los datos personales se conservarán durante el tiempo necesario para cumplir con la finalidad para la que se recabaron y para determinar las posibles responsabilidades que se pudieran derivar de dicha finalidad y del tratamiento de los datos, además de los períodos establecidos en la normativa de archivos y documentación.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Derechos del Usuario</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Los usuarios tienen derecho a:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li><strong>Acceso:</strong> Conocer qué datos personales estamos tratando</li>
                <li><strong>Rectificación:</strong> Solicitar la corrección de datos inexactos</li>
                <li><strong>Supresión:</strong> Solicitar la eliminación de sus datos</li>
                <li><strong>Oposición:</strong> Oponerse al tratamiento de sus datos</li>
                <li><strong>Limitación:</strong> Solicitar la limitación del tratamiento</li>
                <li><strong>Portabilidad:</strong> Recibir sus datos en formato estructurado</li>
              </ul>
              <p className="text-gray-700 leading-relaxed mt-4">
                Para ejercer estos derechos, puede contactarnos en info@protecplus.es o en nuestra dirección postal.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">8. Seguridad de los Datos</h2>
              <p className="text-gray-700 leading-relaxed">
                PROTECPLUS INGENIERÍA ha adoptado medidas técnicas y organizativas apropiadas para garantizar un nivel de seguridad adecuado al riesgo, que protejan los datos personales contra la destrucción, pérdida o alteración accidental o ilícita, o la comunicación o acceso no autorizados.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">9. Comunicación de Datos</h2>
              <p className="text-gray-700 leading-relaxed">
                Los datos no serán comunicados a terceros, salvo obligación legal o cuando sea necesario para la prestación del servicio contratado.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">10. Modificaciones</h2>
              <p className="text-gray-700 leading-relaxed">
                PROTECPLUS INGENIERÍA se reserva el derecho a modificar la presente política para adaptarla a novedades legislativas o jurisprudenciales, así como a prácticas de la industria. Cualquier modificación será publicada en este sitio web.
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
